<template>
  <div
    :class="[
      'retail-connect-online-retailer-fi',
      variant ? `retail-connect-online-retailer-fi--${variant}` : null,
    ]"
    data-test="retail-connect-retailer"
  >
    <div class="retail-connect-online-retailer-fi__top">
      <div class="retail-connect-online-retailer-fi__image">
        <ssr-cloud-image-fi
          v-if="toCloudimage(retailer.LogoUrl)"
          class="retail-connect-online-retailer-fi__img"
          :src="toCloudimage(retailer.LogoUrl)"
          :breakpoints="[
            {
              mediaWidth: 1023,
              imageWidth: 60,
            },
          ]"
          :unlimited="85"
          trim
          params="func=fit"
        />

        <img
          v-else
          class="retail-connect-online-retailer-fi__img"
          :src="retailer.LogoUrl"
        />
      </div>
      <div class="retail-connect-online-retailer-fi__top__left">
        <div class="retail-connect-online-retailer-fi__image--mobile">
          <ssr-cloud-image-fi
            v-if="toCloudimage(retailer.LogoUrl)"
            class="retail-connect-online-retailer-fi__img"
            :src="toCloudimage(retailer.LogoUrl)"
            :breakpoints="[]"
            :unlimited="60"
            trim
            params="func=fit"
          />
          <img
            v-else
            class="retail-connect-online-retailer-fi__img"
            :src="retailer.LogoUrl"
          />
          <div
            :class="{
              'retail-connect-online-retailer-fi__toggle-details retail-connect-online-retailer-fi__toggle-details--mobile': true,
              'retail-connect-online-retailer-fi__toggle-details--active': showDetails,
            }"
            @click="showDetails = !showDetails"
          >
            {{
              showDetails
                ? $dict.get('retail-Connect-Cart.Checkout.Labels.Close-Details')
                : $dict.get('retail-Connect-Cart.Checkout.Labels.Details')
            }}
            <icon-fi
              class="retail-connect-online-retailer-fi__toggle-details__icon"
              icon="chevron-down"
            />
          </div>
        </div>
        <div
          class="retail-connect-online-retailer-fi__name"
          data-test="retail-connect-retailer-name"
        >
          {{ retailer.Name }}
        </div>

        <link-fi
          class="retail-connect-online-retailer-fi__shop-link"
          :href="retailer.ShopLink?.[0]"
          target="_blank"
          rel="noopener"
          data-test="retail-connect-retailer-shop-link"
          @click.capture="trackEvent"
          @click.middle="trackEvent"
        >
          {{ $dict.get('product-Catalog.Retail.Buttons.To-Online-Shop') }}
        </link-fi>
      </div>

      <div class="retail-connect-online-retailer-fi__top__right">
        <div
          :class="{
            'retail-connect-online-retailer-fi__toggle-details': true,
            'retail-connect-online-retailer-fi__toggle-details--active': showDetails,
          }"
          @click="showDetails = !showDetails"
        >
          {{
            showDetails
              ? $dict.get('retail-Connect-Cart.Checkout.Labels.Close-Details')
              : $dict.get('retail-Connect-Cart.Checkout.Labels.Details')
          }}
          <icon-fi
            class="retail-connect-online-retailer-fi__toggle-details__icon"
            icon="chevron-down"
          />
        </div>
        <div
          v-if="unavailableProducts.length === 0 && !isProductRetailers"
          class="retail-connect-online-retailer-fi__status retail-connect-online-retailer-fi__status--available"
        >
          {{ $dict.get('product-Catalog.Retail.Availability.Available') }}
        </div>

        <template v-if="unavailableProducts.length !== 0 && !isProductRetailers">
          <div
            class="retail-connect-online-retailer-fi__status retail-connect-online-retailer-fi__status--unavailable"
          >
            {{
              unavailableProducts.length === 1
                ? $dict.get('product-Catalog.Retail.Availability.Partially-Unavailable-Singular')
                : $dict.get('product-Catalog.Retail.Availability.Partially-Unavailable', [
                    unavailableProducts.length,
                  ])
            }}
          </div>
        </template>
      </div>
    </div>

    <div class="retail-connect-online-retailer-fi__content">
      <slide-up-down-fi :model-value="showDetails">
        <div class="retail-connect-online-retailer-fi__data">
          <div class="retail-connect-online-retailer-fi__data__row">
            <div class="retail-connect-online-retailer-fi__data__label">
              {{ dict('BusinessTypes') }}
            </div>
            <div class="retail-connect-online-retailer-fi__data__value">
              {{ activeTypes(retailer.BusinessTypes) }}
            </div>
          </div>
          <div class="retail-connect-online-retailer-fi__data__row">
            <div class="retail-connect-online-retailer-fi__data__label">
              {{ dict('DeliveryTypes') }}
            </div>
            <div class="retail-connect-online-retailer-fi__data__value">
              {{ activeTypes(retailer.DeliveryTypes) }}
            </div>
          </div>

          <div class="retail-connect-online-retailer-fi__data__row">
            <div class="retail-connect-online-retailer-fi__data__label">
              {{ dict('PaymentTypes') }}
            </div>
            <div class="retail-connect-online-retailer-fi__data__value">
              {{ activeTypes(retailer.PaymentTypes) }}
            </div>
          </div>
        </div>
      </slide-up-down-fi>

      <div
        v-if="unavailableProducts.length !== 0"
        class="retail-connect-online-retailer-fi__unavailable-products"
      >
        <retail-connect-unavailable-products-fi :products="unavailableProducts" />
      </div>
    </div>
  </div>
</template>

<script>
import { IconFi, LinkFi, SlideUpDownFi, SsrCloudImageFi } from 'atoms';
import { retailConnectTranslation } from 'components/retail-connect/retail-connect-online-retailer/RetailConnectTranslation';
import breakpointMixin from 'mixins/breakpointMixin';
import eventHubMixin from 'mixins/eventHubMixin';
import shoppingcartMixin from 'mixins/shoppingcartMixin';

import RetailConnectUnavailableProductsFi from './retail-connect-unavailable-products/RetailConnectUnavailableProductsFi';

export default {
  name: 'RetailConnectOnlineRetailerFi',
  components: {
    IconFi,
    LinkFi,
    RetailConnectUnavailableProductsFi,
    SlideUpDownFi,
    SsrCloudImageFi,
  },
  mixins: [breakpointMixin, shoppingcartMixin, eventHubMixin],
  props: {
    retailer: {
      type: Object,
      default: () => ({}),
    },
    variant: {
      type: String,
      default: null,
    },
    cartId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: true,
      showDetails: false,
    };
  },
  computed: {
    unavailableProducts() {
      return this.retailer.Products.filter(
        (product) => product.stock === 'EMPTY' || product.stock === null,
      );
    },
    isProductRetailers() {
      return this.variant === 'product-retailers';
    },
  },
  methods: {
    toCloudimage(url) {
      if (url.includes('www.nexmart.com/media/customer')) {
        return url.replace(/^https:\/\/www\.nexmart\.com\/media\/customer/, '_retail-connect_');
      }

      return null;
    },
    dict(type) {
      return retailConnectTranslation(type, this.$dict);
    },
    activeTypes(types) {
      const activeTypes = [];

      Object.entries(types || {}).forEach(([key, value]) => {
        if (key !== '__typename' && value) {
          activeTypes.push(retailConnectTranslation(key, this.$dict));
        }
      });

      return activeTypes.join(', ');
    },
    async trackEvent() {
      if (!IS_SSR) {
        const eventHubProducts = this.retailer?.Products.map((product) => {
          return {
            productId: product?.catalogData?.id,
            available: Boolean(product.stock && product.stock !== 'EMPTY'),
          };
        });
        this.sendEvent('retail_connect_online', {
          retailerName: this.retailer.Name,
          items: eventHubProducts,
          cartId: this.cartId,
        });

        await this.getCart();
        this.trackOnlineRetailerClicked(this.cart, this.retailer.Name);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import './retail-connect-online-retailer-fi';
</style>
